/* eslint-disable no-param-reassign */
import React, {Component} from "react";
import styles from "./styles";
import classNames from "classnames";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {bindActionCreators} from "redux";
import {filters, canvas as canvasStore, pois} from "../../store";
import {withStyles, Button} from "@material-ui/core";
import {ReactComponent as ArrowLeftIcon} from "../../assets/images/icons/arrowLeft.svg";
import {ReactComponent as ArrowRightIcon} from "../../assets/images/icons/arrowRight.svg";
import {Popup} from "./partials";

import {ReactComponent as LightOnIcon} from "../../assets/images/icons/light-on.svg";
import {ReactComponent as LightOffIcon} from "../../assets/images/icons/light-off.svg";
import {theme} from "../../utils/ThemeProvider";
import * as PIXI from "pixi.js";

import Draggable from "gsap/Draggable";
import lciHelper from "./partials/lci";
// import registerMouseWheel from "./partials/mouseWheelEvent";
import {Viewport} from "pixi-viewport";
// import { setFrame } from "../../store/canvas";
import {ProgressBar} from "../../components";

let Animator = null;
let AnimatorSprite = null;
let CanvasContainer = null;
let self = null;
const GLOBAL_POIS = {};
const GLOBAL_POLYGONS = {};
const GLOBAL_TEXTURES = {};
const lcis = {};
const textures = {};

class Canvas extends Component {
	constructor(props) {
		super(props);

		self = this;
	}

	state = {
		progress: this.isLoaded ? 100 : 0,
		frames: [],
		framesCount: 90,
		counter: 1,
		zoom: 1,
		maxZoom: 2,
		filteredIds: [],
		pois: {},
		floors: {},
		loaded: 0,
		startX: null,
		startY: null,
		stage: null,
		canvas: null,
		popup: {
			x: 0,
			y: 0,
			open: false,
			poi: null,
			color: "inherit"
		},
		direction: 1,
		mouseTrigger: false,
		rollInterval: false,
		stateLights: true,
		currentPOI: false,
		isInit: true
	};

	holdInterval = false;
	progressInterval = false;
	isLoaded = false;

	componentDidMount() {
		let {helperChooser} = this.props;
		const {setFrame} = this.props;

		if (this.props.poi) {
			helperChooser = "lci";
		}
		switch (helperChooser) {
			case "floor":
				break;
			case "lci":
				const frame = lciHelper.findLci(this);
				setFrame(frame);
				break;
			default:
				break;
		}
		this.setState({
			framesCount: this.props.floorsImages.all.length - 1
		});
		this.props.fetchPois();
		this.init();
	}

	componentDidUpdate(prevProps) {
		if (this.isLoaded) {
			const {filteredIds, stateLights} = this.state;
			const {
				ids,
				lights,
				floor,
				frame,
				hoveredLot,
				data,
				shapes,
				poi,
				hasFloors,
				setFrame
			} = this.props;

			if (JSON.stringify(filteredIds) !== JSON.stringify(ids)) {
				this.setState({filteredIds: ids});
			}
			if (lights !== stateLights) {
				this.setState({
					stateLights: lights
				});
			}
			if (JSON.stringify(prevProps.floor) !== JSON.stringify(floor)) {
				this.setAssets();
			}

			if (prevProps.hoveredLot !== hoveredLot) {
				if (
					!(
						hasFloors &&
						((typeof floor === "string" && floor !== "all") ||
							(typeof floor === "object" && floor[0] !== "all"))
					)
				) {
					if (hoveredLot) {
						AnimatorSprite.children.forEach(circle => {
							if (!circle.isLci && circle.lot === hoveredLot) {
								circle.clear();
								circle.beginFill(circle.textColor, 1);
								circle.drawCircle(0, 0, 22);
								circle.endFill();
								if (circle.children && circle.children.length > 0) {
									circle.children[0].style = {
										fontFamily: ["Questrial", "Arial", "sans", "sans-serif"],
										fontSize: 16,
										fill: circle.color,
										align: "center"
									};
								}
							}
						});
					} else {
						AnimatorSprite.children.forEach(circle => {
							if (!circle.isLci) {
								circle.clear();
								circle.beginFill(circle.color, 1);
								circle.drawCircle(0, 0, 22);
								circle.endFill();
								if (circle.children && circle.children.length > 0) {
									circle.children[0].style = {
										fontFamily: ["Questrial", "Arial", "sans", "sans-serif"],
										fontSize: 16,
										fill: circle.textColor,
										align: "center"
									};
								}
							}
						});
					}
				}
			}
			this.setUpdateState();
		}
	}

	setTextures() {
		return new Promise((resolve, reject) => {
			const promises = [];
			const {floor, floorsImages} = this.props;
			// if (!GLOBAL_TEXTURES[floor]) {
			// 	this.loadFloorTextures(floor).then(() => {
			// 		resolve(true);
			// 		this.setTextures().then(() => {
			// 			console.log(true);
			// 		});
			// 	});
			// } else {
			const floors = Object.keys(floorsImages);
			floors.forEach(fl => {
				if (floor !== fl && !GLOBAL_TEXTURES[fl]) {
					promises.push(this.loadFloorTextures(fl));
				}
			});
			Promise.all(promises).then(() => {
				resolve(true);
			});
			// }
		});
	}

	componentWillUnmount() {
		// AnimatorSprite.children.map(circle => {
		// 	circle.off();
		// 	return circle;
		// });
	}

	updateGlobalFrame(isMulti = false) {
		const {ids, lights, frame} = self.props;
		let data = GLOBAL_POIS;
		if (isMulti) {
			data = GLOBAL_POLYGONS;
		}
		Object.keys(data).map(lot => {
			const child = data[lot];
			let coord = child.columns[frame];
			if (
				!coord ||
				(this.props.poi && this.props.poi !== lot) ||
				ids.indexOf(lot) === -1 ||
				!lights
			) {
				if (isMulti) {
					coord = [-1920, -1080];
				} else {
					coord = {x: -1920, y: -1080};
				}
			}

			if (isMulti) {
				child.clear();
				child.beginFill(child.color);
				child.drawPolygon(coord);
			} else {
				const {x, y} = coord;
				child.x = x;
				child.y = y;
			}
			return child;
		});

		AnimatorSprite.gotoAndStop(this.props.frame);
	}

	updateFrame(targetFrame) {
		const func = delta => {
			const {counter} = this.state;
			this.setState(state => ({
				counter: state.counter + delta
			}));

			const count = this.state.framesCount - 1;
			let index = Math.round(((counter % 360) / 360) * count);

			index = index < 1 ? count + index : index - 1;

			this.props.setFrame(index);
			AnimatorSprite.gotoAndStop(index);
			if (this.props.frame === targetFrame) {
				Animator.ticker.remove(func);
				this.setUpdateState();
			}
		};
		Animator.ticker.add(func);
	}

	updateImage(event) {
		if (
			event &&
			(event.which === 2 || event.button === 4 || event.buttons === 4)
		) {
			return true;
		}
		// console.log(Number(-Math.sign(this.deltaX)));
		// if (self.props.poi) {
		return self.rotate(Number(-Math.sign(this.deltaX)));
		// }

		self.setState(state => ({
			counter: state.counter + this.deltaX * 0.2
		}));

		const count = self.state.framesCount - 1;
		let index = Math.round(((self.state.counter % 360) / 360) * count);

		index = index < 1 ? count + index : index - 1;

		self.props.setFrame(index);

		self.setUpdateState();
		return true;
	}

	checkOuterLimits = frame => {
		const {framesCount} = this.state;

		if (frame >= framesCount) {
			return 0;
		}
		if (frame < 0) {
			return framesCount - 1;
		}
		return frame;
	};

	onAssetsLoaded = () => {
		const proxyTrigger = document.getElementById("proxyTrigger");
		const proxy = document.getElementById("proxy");

		const {width} = Animator.renderer;
		const {height} = Animator.renderer;
		const worldWidth = Animator.renderer.width;
		const worldHeight = Animator.renderer.height;
		const worldMinX = 0;
		const worldMinY = 0;
		const worldMaxX = worldWidth;
		const worldMaxY = worldHeight;

		if (CanvasContainer) {
			CanvasContainer.destroy();
			CanvasContainer = null;
		}

		CanvasContainer = new Viewport({
			screenWidth: width,
			screenHeight: height,
			worldWidth,
			worldHeight,
			interaction: Animator.renderer.plugins.interaction,
			noTicker: true
		});

		this.initAnimatedSprite("all");

		CanvasContainer.addChild(AnimatorSprite);

		let currentFloorPois = this.props.pois;

		currentFloorPois.forEach(item => {
			const [lot] = Object.keys(item);
			const poi = item[lot];
			let X = 0;
			let Y = 0;

			const circle = new PIXI.Graphics();
			// Opt-in to interactivity
			circle.interactive = true;

			// Shows hand cursor
			circle.buttonMode = true;
			circle.lineStyle(0);

			const textColor = parseInt(`0x${"#ffffff".slice(1)}`, 16); // theme.palette.primary.contrastText;
			let type = this.props.data[lot].type.replace(/\D/u, "");
			if (
				this.props.data[lot].type === "ST" ||
				this.props.data[lot].type === "st"
			) {
				type = 1;
			}
			let color = theme.app[`backgroundColor${type}`];
			if (!color) {
				color = theme.app.default;
			}

			color = parseInt(`0x${color.slice(1)}`, 16);

			const text = new PIXI.Text(lot, {
				fontFamily: [
					// "Questrial",
					"Arial",
					"sans",
					"sans-serif"
				],
				fontSize: 16,
				fill: textColor,
				align: "center"
			});

			circle.beginFill(color, 1);
			circle.drawCircle(0, 0, 22);
			circle.endFill();
			circle.lot = lot;
			circle.color = color;
			circle.textColor = textColor;

			circle.columns = {};

			poi.coordinates.forEach(coordinate => {
				const frame = Number(coordinate._column);
				X = coordinate._x * 1920;
				Y = coordinate._y * 1080;

				circle.columns[frame] = {
					x: X,
					y: Y
				};

				text.x = 0 - 15;
				text.y = 0 - 10;

				if (frame === this.props.frame) {
					circle.x = X;
					circle.y = Y;
				}

				circle.on("mouseover", () => {
					circle.clear();
					circle.beginFill(textColor, 1);
					circle.drawCircle(0, 0, 22);
					circle.endFill();
					text.style = {
						fontFamily: ["Questrial", "Arial", "sans", "sans-serif"],
						fontSize: 16,
						fill: color,
						align: "center"
					};
					circle.addChild(text);
					return false;
				});
				circle.on("mouseout", () => {
					circle.clear();
					circle.beginFill(color, 1);
					circle.drawCircle(0, 0, 22);
					circle.endFill();
					text.style = {
						fontFamily: ["Questrial", "Arial", "sans", "sans-serif"],
						fontSize: 16,
						fill: textColor,
						align: "center"
					};
					circle.addChild(text);
					return false;
				});
				circle.on("click", () => {
					this.props.history.push(`/lot/${lot}`);
					return false;
				});
				circle.on("tap", () => {
					this.props.history.push(`/lot/${lot}`);
					return false;
				});


				circle.addChild(text);
			});

			GLOBAL_POIS[lot] = circle;
			CanvasContainer.addChild(circle);
		});

		CanvasContainer.left = worldMinX;
		CanvasContainer.top = worldMinY;
		CanvasContainer.right = worldMaxX;
		CanvasContainer.bottom = worldMaxY;
		CanvasContainer.fitWidth(worldWidth, false, false)
			.fitHeight(worldHeight, false, false)
			.drag({
				mouseButtons: "middle"
			})
			.wheel({
				percent: 0.1
			})
			.decelerate()
			.clampZoom({
				minWidth: worldWidth / 1.5,
				minHeight: worldHeight / 1.5,
				maxWidth: worldWidth,
				maxHeight: worldHeight
			})
			.clamp({
				left: worldMinX,
				right: worldMinX + worldWidth,
				top: worldMinY,
				bottom: worldMinY + worldHeight
			});
		Animator.stage.addChild(CanvasContainer);

		Draggable.create(proxy, {
			type: "x",
			throwProps: true,
			trigger: proxyTrigger,
			onDrag: this.updateImage,
			onThrowUpdate: this.updateImage,
			cursor: "arrow",
			maxDuration: 2.0,
			lockAxis: true
		});
	};
	onAssetsLoadedMultiFloor = () => {
		let {floor, data} = this.props;
		const proxyTrigger = document.getElementById("proxyTrigger");
		const proxy = document.getElementById("proxy");

		const {width} = Animator.renderer;
		const {height} = Animator.renderer;
		const worldWidth = Animator.renderer.width;
		const worldHeight = Animator.renderer.height;
		const worldMinX = 0;
		const worldMinY = 0;
		const worldMaxX = worldWidth;
		const worldMaxY = worldHeight;

		if (typeof floor !== "string") {
			floor = floor[0];
		}

		this.initAnimatedSprite(floor);

		CanvasContainer = new Viewport({
			screenWidth: width,
			screenHeight: height,
			worldWidth,
			worldHeight,
			interaction: Animator.renderer.plugins.interaction,
			noTicker: true
		});

		CanvasContainer.addChild(AnimatorSprite);
		CanvasContainer.left = worldMinX;
		CanvasContainer.top = worldMinY;
		CanvasContainer.right = worldMaxX;
		CanvasContainer.bottom = worldMaxY;
		CanvasContainer.fitWidth(worldWidth, false, false)
			.fitHeight(worldHeight, false, false)
			.drag({
				mouseButtons: "middle"
			})
			.wheel({
				percent: 0.1
			})
			.decelerate()
			.clampZoom({
				minWidth: worldWidth / 1.5,
				minHeight: worldHeight / 1.5,
				maxWidth: worldWidth,
				maxHeight: worldHeight
			})
			.clamp({
				left: worldMinX,
				right: worldMinX + worldWidth,
				top: worldMinY,
				bottom: worldMinY + worldHeight
			});
		CanvasContainer.mousemove = function (event) {
			self.setState(prevState => {
				prevState.popup.x = event.data.originalEvent.clientX - 90;
				prevState.popup.y = event.data.originalEvent.clientY + 24;
				return {
					...prevState
				};
			});
		};

		const currentFloorPois = this.props[floor].pois;

		currentFloorPois.forEach(item => {
			const [lot] = Object.keys(item);
			const poi = item[lot];
			const vertices = {};
			const columns = [];

			const polygon = new PIXI.Graphics();

			const textColor = parseInt(`0x${"#ffffff".slice(1)}`, 16); // theme.palette.primary.contrastText;
			let type = this.props.data[lot].type.replace(/\D/u, "");
			if (
				this.props.data[lot].type === "ST" ||
				this.props.data[lot].type === "st"
			) {
				type = 1;
			}
			let color = theme.app[`backgroundColor${type}`];
			if (!color) {
				color = theme.app.default;
			}
			const nativeColor = color;

			color = parseInt(`0x${color.slice(1)}`, 16);

			const text = new PIXI.Text(lot, {
				fontFamily: [
					// "Questrial",
					"Arial",
					"sans",
					"sans-serif"
				],
				fontSize: 16,
				fill: textColor,
				align: "center"
			});
			// polygon.coordinates = vertices;
			if (!polygon.columns) {
				polygon.columns = [];
			}

			polygon.lot = lot;
			polygon.color = color;
			polygon.textColor = textColor;
			polygon.beginFill(color);

			// polygon.hitArea = vertices[self.state.frame];
			polygon.interactive = true;
			polygon.buttonMode = true;
			polygon.alpha = 0.7;
			polygon.mouseover = function () {
				polygon.alpha = 0.5;
				self.setState({
					popup: {
						open: true,
						color: nativeColor,
						poi: data[lot]
					}
				});
			};
			polygon.mouseout = function () {
				polygon.alpha = 0.7;
				self.setState({
					popup: {
						open: false
					}
				});
			};

			polygon.on("click", () => {
				this.props.history.push(`/lot/${lot}`);
				return false;
			});
			poi.coordinates.forEach(coordinate => {
				const vert = [];
				coordinate._vertices.split(";").forEach(vertice => {
					const tmp = vertice.split(",");
					vert.push({
						x: 1920 * tmp[0],
						y: 1080 * tmp[1]
					});
				});
				const frame = coordinate._column;

				polygon.columns[frame] = vert;

				console.log(polygon.drawPolygon(vert));
			});

			GLOBAL_POLYGONS[lot] = polygon;
			CanvasContainer.addChild(polygon);
		});

		Animator.stage.addChild(CanvasContainer);

		Draggable.create(proxy, {
			type: "x",
			throwProps: true,
			trigger: proxyTrigger,
			onDrag: this.updateImage,
			onThrowUpdate: this.updateImage,
			cursor: "arrow",
			maxDuration: 2.0,
			lockAxis: true
		});
	};
	onAssetsLoadedLci = () => {
		const proxyTrigger = document.getElementById("proxyTrigger");
		const proxy = document.getElementById("proxy");

		const {width} = Animator.renderer;
		const {height} = Animator.renderer;
		const worldWidth = Animator.renderer.width;
		const worldHeight = Animator.renderer.height;
		const worldMinX = 0;
		const worldMinY = 0;
		const worldMaxX = worldWidth;
		const worldMaxY = worldHeight;

		CanvasContainer = new Viewport({
			screenWidth: width,
			screenHeight: height,
			worldWidth,
			worldHeight,
			interaction: Animator.renderer.plugins.interaction,
			noTicker: true
		});

		this.initAnimatedSprite("all");

		CanvasContainer.addChild(AnimatorSprite);

		let currentFloorPois = this.props.pois;

		CanvasContainer.addChild(AnimatorSprite);
		CanvasContainer.left = worldMinX;
		CanvasContainer.top = worldMinY;
		CanvasContainer.right = worldMaxX;
		CanvasContainer.bottom = worldMaxY;
		CanvasContainer.fitWidth(worldWidth, false, false)
			.fitHeight(worldHeight, false, false)
			.drag({
				mouseButtons: "middle"
			})
			.wheel({
				percent: 0.1
			})
			.decelerate()
			.clampZoom({
				minWidth: worldWidth / 1.5,
				minHeight: worldHeight / 1.5,
				maxWidth: worldWidth,
				maxHeight: worldHeight
			})
			.clamp({
				left: worldMinX,
				right: worldMinX + worldWidth,
				top: worldMinY,
				bottom: worldMinY + worldHeight
			});
		Animator.stage.addChild(CanvasContainer);

		currentFloorPois.forEach(item => {
			const [lot] = Object.keys(item);
			if (this.props.poi === lot) {
				const lciCircle1 = new PIXI.Graphics();
				const lciRectangle = new PIXI.Graphics();
				const lciCircle2 = new PIXI.Graphics();
				const lciCircle3 = new PIXI.Graphics();
				const lci = new PIXI.Container();

				const textColor = parseInt(`0x${"#ffffff".slice(1)}`, 16); // theme.palette.primary.contrastText;
				let type = this.props.data[lot].type.replace(/\D/u, "");
				if (
					this.props.data[lot].type === "ST" ||
					this.props.data[lot].type === "st"
				) {
					type = 1;
				}
				let color = theme.app[`backgroundColor${type}`];
				if (!color) {
					color = theme.app.default;
				}

				color = parseInt(`0x${color.slice(1)}`, 16);

				const lciText = new PIXI.Text("lci", {
					fontFamily: [
						// "Questrial",
						"Arial",
						"sans",
						"sans-serif"
					],
					fontSize: 24,
					fill: color,
					align: "center"
				});

				lciCircle1.lineStyle(0);
				lciCircle1.beginFill(0xffffff, 1);
				lciCircle1.drawCircle(-120, 0, 25);
				lciCircle1.endFill();
				lciText.x = -133;
				lciText.y = -15;
				lciCircle1.addChild(lciText);

				lciRectangle.beginFill(0xffffff);
				lciRectangle.drawRect(-110, -5, 60, 10);
				lciRectangle.endFill();
				lciCircle2.lineStyle(0);
				lciCircle2.beginFill(0xffffff, 1);
				lciCircle2.drawCircle(-50, 0, 12);
				lciCircle2.endFill();
				lciCircle3.lineStyle(10, color, 1);
				lciCircle3.beginFill(0xffffff, 0);
				lciCircle3.drawCircle(0, 0, 50);
				lciCircle3.endFill();
				lci.addChild(lciRectangle);
				lci.addChild(lciCircle3);
				lci.addChild(lciCircle1);
				lci.addChild(lciCircle2);
				lci.lot = lot;
				lci.color = color;
				lci.textColor = textColor;

				const poi = item[lot];
				let X = 0;
				let Y = 0;
				let Xlci = 0;
				let Ylci = 0;
				const vertices = {};
				if (!lci.columns) {
					lci.columns = {};
				}

				poi.coordinates.forEach(coordinate => {
					const frame = coordinate._column;
					lci.columns[frame] = {
						x: coordinate._x * 1920,
						y: coordinate._y * 1080
					};
					if (frame === this.props.frame) {
						lci.x = lci.columns[frame].x;
						lci.y = lci.columns[frame].y;
					}
				});

				lci.isLci = true;

				GLOBAL_POIS[lot] = lci;
				CanvasContainer.addChild(lci);
			}
		});

		Draggable.create(proxy, {
			type: "x",
			throwProps: true,
			trigger: proxyTrigger,
			onDrag: this.updateImage,
			onThrowUpdate: this.updateImage,
			cursor: "arrow",
			maxDuration: 2.0,
			lockAxis: true
		});
	};

	init() {
		const $target = document.getElementById("target");
		Animator = new PIXI.Application({
			width: 1920,
			height: 1080,
			transparent: true,
			backgroundColor: 0xffffff,
			// resizeTo: $target,
			antialias: true,
			forceCanvas: true
		});
		$target.appendChild(Animator.view);
		if (!this.isLoaded) {
			this.firstLaunch();
			this.setAssets();
			this.setTextures().then(() => {
				this.isLoaded = true;
				this.setAssets();
				this.setUpdateState();

				this.setState({progress: 100});
			});
			this.setUpdateState();
		} else {
			this.setAssets();
			this.setState({progress: 100});
			this.setUpdateState();
		}
	}

	firstLaunch() {
		const {floorsImages, floor} = this.props;
		const floorImages = floorsImages[floor];

		GLOBAL_TEXTURES[floor] = [];

		floorImages.forEach((image, index) => {
			GLOBAL_TEXTURES[floor].push(PIXI.Texture.from(image));
		});
	}

	initAnimatedSprite(floor) {
		AnimatorSprite = new PIXI.AnimatedSprite(GLOBAL_TEXTURES[floor]);

		AnimatorSprite.x = Animator.renderer.width / 2;
		AnimatorSprite.y = Animator.renderer.height / 2;
		AnimatorSprite.width = Animator.renderer.width;
		AnimatorSprite.height = Animator.renderer.height;
		AnimatorSprite.anchor.set(0);
		AnimatorSprite.loop = true;
		AnimatorSprite.animationSpeed = 0.0001;
		AnimatorSprite.position.x = 0;
		AnimatorSprite.position.y = 0;
	}

	loadFloorTextures(floor) {
		const {floorsImages} = this.props;
		const floorImages = floorsImages[floor];
		const pixiLoader = new PIXI.Loader();
		return new Promise((resolve, reject) => {
			if (!GLOBAL_TEXTURES[floor]) {
				pixiLoader.onComplete.add(f => {
					if (this.state.progress < f.progress) {
						this.setState({progress: f.progress});
					}
					resolve();
				});
				pixiLoader.onProgress.add(f => {
					if (this.state.progress < f.progress) {
						this.setState({progress: f.progress});
					}
				});
				floorImages.forEach((image, index) => {
					pixiLoader.add(`${floor}-${index}`, image);
				});

				pixiLoader.load((loader, resources) => {
					GLOBAL_TEXTURES[floor] = Object.keys(resources).map(key => {
						return resources[key];
					});
				});
			}
		});
	}

	setAssets() {
		const {poi, floor, hasFloors} = this.props;
		if (poi) {
			this.onAssetsLoadedLci();
		} else if (
			hasFloors &&
			((typeof floor === "string" && floor !== "all") ||
				(typeof floor === "object" && floor[0] !== "all"))
		) {
			this.onAssetsLoadedMultiFloor();
		} else {
			this.onAssetsLoaded();
		}
	}

	setUpdateState() {
		const {poi, floor, hasFloors} = this.props;
		const isMulti =
			!poi &&
			hasFloors &&
			((typeof floor === "string" && floor !== "all") ||
				(typeof floor === "object" && floor[0] !== "all"));

		this.updateGlobalFrame(isMulti);
	}

	holdAnimation = dir => {
		if (!this.holdInterval) {
			this.holdInterval = setInterval(() => {
				this.props.setFrame(this.checkOuterLimits(this.props.frame + dir));
				this.setUpdateState();
			}, 100);
		}
	};

	endAnimation = () => {
		if (this.holdInterval) {
			clearInterval(this.holdInterval);
			this.holdInterval = false;
		}
	};

	rotate(dir) {
		// if ((!this.props.poi && this.holdInterval) || this.props.poi) {
		this.props.setFrame(this.checkOuterLimits(this.props.frame - dir));
		this.setUpdateState();
		// }
	}

	render() {
		const {classes, poi, lights, toggleLights, hasFloors, floor} = this.props;
		const {popup} = this.state;

		return (
			<div
				style={{
					position: "relative"
				}}
			>
				<div id="proxyTrigger">
					<div id="target"/>
					<div id="proxy"/>
				</div>
				<Popup popup={popup}/>
				<div className={classes.arrowsContainer}>
					<Button
						className={classNames(classes.arrows, classes.arrowLeft)}
						variant="contained"
						color="primary"
						onMouseDown={() => {
							this.holdAnimation(1);
						}}
						onMouseUp={this.endAnimation}
						onTouchStart={() => {
							this.holdAnimation(1);
						}}
						onTouchEnd={this.endAnimation}
						onMouseLeave={this.endAnimation}
						onClick={() => this.rotate(-1)}
					>
						<ArrowLeftIcon className={classNames(classes.arrowIcon)}/>
					</Button>
					<Button
						className={classNames(classes.arrows, classes.arrowRight)}
						variant="contained"
						color="primary"
						onMouseDown={() => {
							this.holdAnimation(-1);
						}}
						onMouseUp={this.endAnimation}
						onTouchStart={() => {
							this.holdAnimation(-1);
						}}
						onTouchEnd={this.endAnimation}
						onMouseLeave={this.endAnimation}
						onClick={() => this.rotate(1)}
					>
						<ArrowRightIcon className={classNames(classes.arrowIcon)}/>
					</Button>
					{poi || (hasFloors && floor !== "all") ? null : (
						<Button
							color="primary"
							variant="contained"
							className={classNames(classes.arrows)}
							onClick={toggleLights}
						>
							{lights ? (
								<LightOnIcon
									className={classNames(
										classes.primaryColor,
										classes.arrowIcon,
										classes.eye
									)}
								/>
							) : (
								<LightOffIcon
									className={classNames(
										classes.primaryColor,
										classes.arrowIcon,
										classes.eye
									)}
								/>
							)}
						</Button>
					)}
				</div>
				<ProgressBar progress={this.state.progress}/>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		...state.filtered[state.helpers.building],
		...state.canvas[state.helpers.building],
		pois: state.canvas[state.helpers.building].all.pois,
		data: state.pois[state.helpers.building],
		lci: state.canvas[state.helpers.building].lci,
		floor: state.filters[state.helpers.building].floor,
		lights: state.canvas[state.helpers.building].lights,
		currentBuilding: state.helpers.building
	};
};

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			setFloor: filters.setFloor,
			setCanvasImages: canvasStore.setCanvasImages,
			setFrame: canvasStore.setFrame,
			toggleLights: canvasStore.toggleLights,
			fetchPois: pois.fetchPois
		},
		dispatch
	);

Canvas.propTypes = {
	classes: PropTypes.object.isRequired,
	floor: PropTypes.any.isRequired,
	// floors: PropTypes.object.isRequired,
	floorsImages: PropTypes.object.isRequired,
	frame: PropTypes.number.isRequired,
	hasFloors: PropTypes.bool.isRequired,
	// helperChooser: PropTypes.string.isRequired,
	ids: PropTypes.array.isRequired,
	lights: PropTypes.bool.isRequired,
	poi: PropTypes.any,
	pois: PropTypes.array.isRequired,
	shapes: PropTypes.object.isRequired
};

Canvas.defaultProps = {
	poi: false
};

export default withRouter(
	withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(Canvas))
);
